import * as t from 'io-ts';
import { createGuard } from 'src_common/common/createGuard';
import { UniverseIO, UniverseType } from 'src_common/common/universe';

const AppEnvParamsIO = t.interface({
    UNIVERSE: UniverseIO,
    OPERATOR: UniverseIO,

    WEBSOCKET_HOST: t.string,
    WEBSOCKET_API_HOST_NEWTRADING: t.string,
    WEBSOCKET_HOST_V2_NEWTRADING: t.string,

    GATEWAY_API_HOST: t.union([t.string, t.undefined]),

    MODE: t.string,
});

const isAppEnvParams = createGuard(AppEnvParamsIO);

export type AppEnvParamsType = t.TypeOf<typeof AppEnvParamsIO>;

export class AppEnvParamsBrowser {
    private readonly params: AppEnvParamsType;

    public constructor(params: AppEnvParamsType) {
        this.params = params;
    }

    public get websocketHost(): string {
        return this.params.WEBSOCKET_HOST;
    }

    public get websocketHostV2(): string {
        return this.params.WEBSOCKET_HOST_V2_NEWTRADING;
    }

    public get websocketApiHost(): string {
        return this.params.WEBSOCKET_API_HOST_NEWTRADING;
    }

    public get universe_theme(): UniverseType {
        return this.params.UNIVERSE;
    }

    public get universe_api(): UniverseType {
        return this.params.OPERATOR;
    }

    public get isProdMode(): boolean {
        return this.params.MODE.toLowerCase() === 'prod';
    }

    public get isGatewayActive(): boolean {
        if (this.params.GATEWAY_API_HOST !== undefined) {
            return true;
        }
        return false;
    }

    public get gatewayUrl(): string {
        if (this.params.GATEWAY_API_HOST !== undefined) {
            return this.params.GATEWAY_API_HOST;
        }
        throw new Error('GATEWAY_API_HOST is undefined');
    }

    public stringify(): string {
        return JSON.stringify(this.params);
    }
}

export const getAppEnvParams = (): AppEnvParamsBrowser => {
    const dataEnv = JSON.parse(document.documentElement.getAttribute('data-env') ?? '');

    if (isAppEnvParams(dataEnv)) {
        return new AppEnvParamsBrowser(dataEnv);
    }

    throw Error('getDataEnv: Incorrect parameters');
};
